import { IconButton } from "@circleco/compass/components/IconButton";
import { Typography } from "@circleco/compass/components/Typography";
import { noop } from "lodash";

import { t } from "@/i18n-js/instance";

interface HeaderProps {
  onClose: () => void;
}

export const Header = ({ onClose = noop }: HeaderProps) => (
  <div className="flex w-full items-center justify-between">
    <Typography variant="heading-md">{t("chat_space.details")}</Typography>
    <IconButton
      icon="cross"
      size="md"
      variant="ghost"
      onClick={onClose}
      aria-label={t("close")}
    />
  </div>
);
